import React from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table';
import propTypes from 'prop-types';
import _ from 'lodash';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { UiPagination } from './UiPagination';
import { InnerLoader, NextButton } from '../common';
import { UiEmptyStateForSars } from './UiEmptyStateForSars';

Object.assign(ReactTableDefaults, {
  LoadingComponent: InnerLoader,
  getLoadingProps: state => ({ visible: state.loading }),
});

const MAX_TABLE_ROWS = 10;

export function UiTableForSars({
  data,
  title,
  emptyTo,
  emptyOnClickButton,
  renderButton,
  paging,
  hideButton,
  loading,
  toNext,
  onClickNext,
  toPrev,
  onClickPrev,
  hideNext,
  hidePrev,
  hideNoDataComponent,
  minRows,
  ...props
}) {
  const noDataComponent = hideNoDataComponent
    ? () => <div />
    : () => (
        <UiEmptyStateForSars
          title={title}
          to={emptyTo}
          onClickButton={emptyOnClickButton}
          renderButton={renderButton}
          hideButton={hideButton}
        />
      );

  return (
    <div className="ui-table">
      <ReactTable
        pageSize={Math.min(MAX_TABLE_ROWS, (data || []).length)}
        minRows={!(data || []).length ? minRows : 0}
        showPagination={false}
        data={data}
        onSortedChange={paging.sort}
        NoDataComponent={noDataComponent}
        loading={loading}
        {...props}
      />
      <Columns isGapless>
        {!hidePrev && (
          <Column isSize="narrow">
            <NextButton to={toPrev} onClick={onClickPrev} isPrev>
              Previous
            </NextButton>
          </Column>
        )}
        <Column>
          <UiPagination
            currentPage={paging.getPaging().page - 1}
            itemsPerPage={paging.getPaging().pageSize}
            onNextPage={paging.next}
            onPrevPage={paging.previous}
            totalItems={paging.getPaging().totalResults}
            onGoToPage={paging.goToPage}
          />
        </Column>
        {!hideNext && (
          <Column isSize="narrow">
            <NextButton to={toNext} onClick={onClickNext} />
          </Column>
        )}
      </Columns>
    </div>
  );
}

UiTableForSars.defaultProps = {
  paging: {
    getPaging: () => ({
      page: 1,
      pageSize: 10,
      totalResults: 0,
    }),
    next: _.noop,
    previous: _.noop,
    sort: _.noop,
    goToPage: _.noop,
  },
  emptyTo: '',
  emptyOnClickButton: null,
  renderButton: null,
  hideButton: false,
  loading: false,
  onClickNext: null,
  toNext: null,
  onClickPrev: null,
  toPrev: null,
  hidePrev: false,
  hideNext: false,
  hideNoDataComponent: false,
  minRows: null,
};

UiTableForSars.propTypes = {
  data: propTypes.arrayOf(propTypes.object).isRequired,
  paging: propTypes.object,
  title: propTypes.string.isRequired,
  emptyTo: propTypes.string,
  emptyOnClickButton: propTypes.func,
  renderButton: propTypes.node,
  hideButton: propTypes.bool,
  loading: propTypes.bool,
  hideNext: propTypes.bool,
  hidePrev: propTypes.bool,
  toNext: propTypes.string,
  onClickNext: propTypes.func,
  toPrev: propTypes.string,
  onClickPrev: propTypes.func,
  hideNoDataComponent: propTypes.bool,
  minRows: propTypes.number,
  ...ReactTable.propTypes,
};
